import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

export default function ProtectedRoute() {
    const isAuthenticated = useSelector(state => state.root.isAuthenticated);
    return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
}
